export const movies = [
  {
    id: "an-yong",
    title: "暗涌",
    enTitle: "Silent Tide",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "剧情"],
    rating: 8.9,
    heat: 9820,
    episodes: 24,
    duration: "45分钟/集",
    director: "沈聿",
    cast: ["陆时宴", "温知夏", "傅寒声", "白露"],
    tagline: "每个人的沉默里，都藏着另一场潮汐。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20lone%20woman%20in%20a%20long%20coat%20standing%20on%20a%20rain-soaked%20harbor%20dock%20at%20night%2C%20dense%20fog%2C%20deep%20navy%20blue%20and%20warm%20amber%20lighting%2C%20soft%20film%20grain%2C%20moody%20mystery%20drama%20aesthetic%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=poster-anyong-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rainy%20coastal%20harbor%20city%20at%20night%2C%20wet%20asphalt%20reflections%2C%20shipping%20containers%20and%20distant%20lighthouse%2C%20deep%20navy%20tones%20with%20warm%20amber%20street%20lamps%2C%20atmospheric%20fog%2C%20film%20grain%20texture%2C%20no%20text&width=1600&height=900&seq=backdrop-anyong-01&orientation=landscape",
    summary:
      "沿海小城接连出现失踪案，刑警顾清让在调查中撞见旧友的秘密。潮水退去后，被掩埋十年的旧案与一段不被允许的情感一同浮出水面。",
    tags: ["多线叙事", "情感博弈", "十集反转"],
    releaseDate: "2025-08-12",
    analysis: [
      {
        title: "第一章 · 潮水下的旧案",
        paragraphs: [
          "开篇并未急于呈现案件，而是用三分钟的空镜交代了这座港城的呼吸：退潮、锈蚀的锚链、码头工人口中的禁忌。导演沈聿把「失踪」处理成一种城市慢性病，而不是突发事故，这为后续的情感线留出了呼吸空间。",
          "顾清让与旧友的重逢看似偶然，实则被剧本埋在第二集的一句闲谈里。当观众回看时会发现，所有证词都指向同一个时间点——十年前的台风夜，那正是整部剧真正的地基。",
        ],
      },
      {
        title: "第二章 · 沉默者的共谋",
        paragraphs: [
          "剧集最锋利的地方在于，它没有把秘密交给反派，而是交给了每一个普通人。邻居、船主、甚至受害者家属，都用「不想再提」换来生活的继续，这种群体性沉默比任何凶手都更让人窒息。",
          "温知夏饰演的角色承担了全剧的情绪枢纽。她的每一次欲言又止都被镜头完整保留，观众能清楚地看到一个人是如何在忠诚与真相之间被慢慢磨碎的。",
        ],
      },
      {
        title: "第三章 · 结局的三处伏笔",
        paragraphs: [
          "大结局没有给出痛快淋漓的审判，而是让真相以最尴尬的方式被公开：没有掌声，只有一屋子的沉默。这种处理让「正义」显得笨拙，却更接近现实。",
          "回看全剧，港口的潮汐表、反复出现的旧收音机、以及那句「水会记住」，构成了三条互相咬合的伏笔，也让结尾那句轻描淡写的告别有了重量。",
        ],
      },
    ],
  },
  {
    id: "chang-ye-jiang-ming",
    title: "长夜将明",
    enTitle: "Before the Dawn",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.5,
    heat: 8760,
    episodes: 16,
    duration: "50分钟/集",
    director: "韩牧",
    cast: ["周砚", "林知微", "罗青山"],
    tagline: "长夜不是用来熬的，是用来查清的。",
    poster:
      "https://readdy.ai/api/search-image?query=Noir%20crime%20series%20poster%20of%20a%20detective%20silhouette%20under%20a%20single%20street%20lamp%20in%20heavy%20rain%2C%20dark%20navy%20and%20muted%20grey%20palette%20with%20one%20amber%20glow%2C%20high%20contrast%2C%20cinematic%20film%20grain%2C%20moody%20urban%20atmosphere%2C%20no%20text&width=600&height=900&seq=poster-changye-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20city%20street%20in%20heavy%20rain%2C%20lone%20figure%20walking%20away%20under%20street%20lamps%2C%20deep%20navy%20shadows%20with%20amber%20highlights%2C%20wet%20reflective%20pavement%2C%20moody%20crime%20thriller%20atmosphere%2C%20no%20text&width=1600&height=900&seq=backdrop-changye-02&orientation=landscape",
    summary:
      "一名被停职的刑警为洗清旧案污名重返一线，他追查的凶手似乎总比自己早一步。十六个夜晚，一次关于制度、良知与执念的长跑。",
    tags: ["硬核推理", "雨夜美学", "双线追凶"],
    releaseDate: "2024-11-03",
    analysis: [
      {
        title: "第一章 · 一个被停职的警察",
        paragraphs: [
          "剧本用大量笔墨写主角的「不合时宜」：他不会用系统，也不屑于讨好上级，这让他在第一集就失去了几乎所有资源。正因如此，后续每一次线索推进都显得昂贵，观众也跟着一起焦虑。",
          "雨夜长镜头是全剧的视觉签名。镜头始终贴着人物后背移动，观众只能看到他看到的东西，这种受限视角让「猜凶手」变成了一场公平的游戏。",
        ],
      },
      {
        title: "第二章 · 凶手的善意",
        paragraphs: [
          "中段最大的转折不是凶手现身，而是凶手在某些时刻表现得比警察更有人情味。剧集故意让观众对反派产生短暂的理解，再用人物的选择把这份理解打碎。",
          "林知微饰演的法医提供了另一种视角：她相信证据，却不相信证据能还原人。两人的对手戏构成了全剧的思想骨架。",
        ],
      },
      {
        title: "第三章 · 天亮之后",
        paragraphs: [
          "结局没有英雄式的胜利。案件结束，城市照常运转，主角只是重新拥有了穿回警服的资格。这种克制的收尾，反而让「长夜将明」这四个字有了余味。",
          "值得二刷的是每一集片头的地点字幕，它们按时间倒序排列，暗示了整部剧其实是一次回溯式的自证。",
        ],
      },
    ],
  },
  {
    id: "chunri-chichi",
    title: "春日迟迟",
    enTitle: "Late Spring",
    year: 2025,
    region: "中国大陆",
    genres: ["爱情", "都市"],
    rating: 8.2,
    heat: 8120,
    episodes: 30,
    duration: "42分钟/集",
    director: "苏禾",
    cast: ["顾南枝", "程砚舟", "许一宁"],
    tagline: "有些春天来得晚，但它终究会来。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20urban%20drama%20poster%20of%20a%20woman%20looking%20out%20of%20a%20sunlit%20old%20apartment%20window%2C%20soft%20cream%20and%20warm%20terracotta%20tones%2C%20dust%20motes%20in%20golden%20afternoon%20light%2C%20gentle%20film%20grain%2C%20quiet%20emotional%20atmosphere%2C%20no%20text&width=600&height=900&seq=poster-chunri-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunlit%20old%20Shanghai%20style%20lane%20with%20laundry%20lines%20and%20potted%20plants%2C%20warm%20late%20afternoon%20light%2C%20soft%20cream%20and%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20nostalgic%20romantic%20film%20still%2C%20no%20text&width=1600&height=900&seq=backdrop-chunri-03&orientation=landscape",
    summary:
      "三十岁的编辑顾南枝在旧公寓里遇见刚搬来的建筑师，两人的生活节奏完全不同，却在一次次错过的春天里，慢慢学会了如何靠近。",
    tags: ["成年人的爱情", "慢节奏", "生活流"],
    releaseDate: "2025-03-21",
    analysis: [
      {
        title: "第一章 · 两个时间表",
        paragraphs: [
          "剧集把矛盾建立在作息而非三观上：一个凌晨改稿，一个清晨出门。导演用大量平行剪辑呈现两人同一屋檐下的错位，让「没时间」成为最真实的情感阻力。",
          "台词写得克制，几乎不出现告白式长句，所有心意都藏在「你吃饭了吗」这类日常里，反而更戳人。",
        ],
      },
      {
        title: "第二章 · 旧公寓的秘密",
        paragraphs: [
          "公寓承担了第三个角色的功能。前租客留下的便签、墙上的旧钉子、楼道里的声控灯，都是两人关系的隐喻。中段关于前租客的支线，看似闲笔，实则解释了女主为何害怕承诺。",
          "这一章的情绪落点很小：一碗放凉的汤。但它把成年人爱情里的自尊与妥协都说尽了。",
        ],
      },
      {
        title: "第三章 · 迟到的春天",
        paragraphs: [
          "结局没有婚礼，只有两个人一起把阳台的花搬进屋。这个动作呼应了第一集的开场，也完成了「家」这个主题的闭环。",
          "如果说有什么遗憾，是配角线略显工具化。但主线的情感密度足以撑住整部剧的温柔。",
        ],
      },
    ],
  },
  {
    id: "jiu-gang-wang-shi",
    title: "旧港往事",
    enTitle: "Harbor Years",
    year: 2023,
    region: "中国香港",
    genres: ["年代", "剧情"],
    rating: 8.7,
    heat: 7420,
    episodes: 32,
    duration: "48分钟/集",
    director: "陈可为",
    cast: ["郑柏川", "何婉华", "叶嘉言"],
    tagline: "码头会拆，人情不会。",
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20drama%20poster%20of%20a%20man%20in%20a%201980s%20shirt%20standing%20on%20a%20cargo%20pier%2C%20sepia%20and%20muted%20teal%20tones%2C%20nostalgic%20film%20grain%2C%20warm%20sunset%20haze%2C%20period%20drama%20aesthetic%2C%20no%20text&width=600&height=900&seq=poster-jiugang-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=1980s%20Hong%20Kong%20cargo%20harbor%20at%20golden%20hour%2C%20cranes%20and%20wooden%20crates%2C%20workers%20silhouettes%2C%20warm%20sepia%20and%20faded%20teal%20palette%2C%20analog%20film%20grain%2C%20nostalgic%20period%20drama%20still%2C%20no%20text&width=1600&height=900&seq=backdrop-jiugang-04&orientation=landscape",
    summary:
      "上世纪八十年代的旧港码头，三代人围绕一间货运行浮沉。三十年的恩怨、义气与离散，都被写进了一本泛黄的账册里。",
    tags: ["年代质感", "群像", "家族叙事"],
    releaseDate: "2023-06-18",
    analysis: [
      {
        title: "第一章 · 账册与义气",
        paragraphs: [
          "开场用一本账册串起三代人的关系网。导演刻意不交代时间，而是让观众从服装、货车型号和收音机里的歌去辨认年代，这种「沉浸式断代」让时代感更可信。",
          "码头不是背景，而是所有人命运的分配器：谁站在哪条栈桥，谁就先拿到货。空间即权力，这是全剧最精妙的设计。",
        ],
      },
      {
        title: "第二章 · 离散的一代",
        paragraphs: [
          "中段的重心从生意转向离别。移民、拆船、迁移，每个人都在离开，留下的只有那间越来越空的货运行。剧集没有煽情，只用一个个空镜把时间推过去。",
          "何婉华的角色是全剧的情感出口。她的沉默不是软弱，而是一种在时代里学会的生存技术。",
        ],
      },
      {
        title: "第三章 · 最后一班船",
        paragraphs: [
          "结局让老码头在机器声里消失，但保留了一盏灯。这个处理把「怀旧」从情绪变成了态度：记忆不是用来复刻的，是用来确认自己从哪来。",
          "三十年后回看，这部剧对群像的耐心在今天已经很少见，值得慢慢看。",
        ],
      },
    ],
  },
  {
    id: "gui-xu",
    title: "归墟",
    enTitle: "The Fallen Deep",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "奇幻"],
    rating: 8.4,
    heat: 9010,
    episodes: 36,
    duration: "46分钟/集",
    director: "江砚",
    cast: ["谢照", "青萝", "玄渡", "沈砚舟"],
    tagline: "万水归处，是墟，也是归途。",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20of%20a%20young%20swordsman%20standing%20before%20a%20giant%20ancient%20stone%20gate%20above%20a%20dark%20sea%2C%20deep%20indigo%20and%20antique%20gold%20palette%2C%20mist%2C%20painterly%20cinematic%20lighting%2C%20epic%20oriental%20fantasy%20aesthetic%2C%20no%20text&width=600&height=900&seq=poster-guixu-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20oriental%20fantasy%20landscape%20of%20floating%20ancient%20stone%20ruins%20above%20a%20dark%20ocean%2C%20swirling%20mist%2C%20deep%20indigo%20sky%20with%20warm%20gold%20light%20breaking%20through%2C%20painterly%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=backdrop-guixu-05&orientation=landscape",
    summary:
      "传说中的归墟吞噬万物，少年谢照为寻找失踪的师父踏入其中。在废墟深处，他遇见了记得所有前尘的少女，也遇见了一个被反复改写的历史。",
    tags: ["东方奇幻", "世界观", "宿命感"],
    releaseDate: "2025-07-05",
    analysis: [
      {
        title: "第一章 · 归墟的规则",
        paragraphs: [
          "前六集几乎都在建立规则：归墟不吞人，吞的是记忆。这个设定让所有战斗都变成了记忆的争夺，也让主角每一次变强都要付出遗忘的代价。",
          "美术团队用大量留白与低饱和的蓝金配色，把「废墟」拍出了宗教感。石阶、断碑、无风自动的经幡，构成了极有辨识度的视觉语言。",
        ],
      },
      {
        title: "第二章 · 记得的人",
        paragraphs: [
          "青萝是全剧最悲剧的角色：她记得所有版本的过去，因此无法相信任何一个现在。她与谢照的对话常常像两个人在不同的时间里说话，这种错位感非常有力量。",
          "中段关于「历史被改写三次」的揭示，把一部奇幻剧抬到了关于记忆政治的层面，这是它最超预期的地方。",
        ],
      },
      {
        title: "第三章 · 归途",
        paragraphs: [
          "结局没有关闭归墟，而是让主角选择带着残缺的记忆回去。这个选择并不壮烈，却符合全剧的逻辑：人不是靠完整的过去活着的。",
          "如果第二季真的开拍，最值得期待的不是更大的场面，而是那些被留下的空白。",
        ],
      },
    ],
  },
  {
    id: "ta-yu-shan-hai",
    title: "她与山海",
    enTitle: "She and the Mountains",
    year: 2024,
    region: "中国台湾",
    genres: ["爱情", "文艺"],
    rating: 8.1,
    heat: 5340,
    episodes: 12,
    duration: "40分钟/集",
    director: "林予安",
    cast: ["沈萄", "江辞", "夏以宁"],
    tagline: "山海很大，装得下一个人的沉默。",
    poster:
      "https://readdy.ai/api/search-image?query=Art%20house%20romance%20poster%20of%20a%20woman%20standing%20on%20a%20coastal%20mountain%20trail%20in%20soft%20morning%20mist%2C%20muted%20sage%20green%20and%20warm%20sand%20tones%2C%20delicate%20film%20grain%2C%20serene%20contemplative%20mood%2C%20no%20text&width=600&height=900&seq=poster-tashan-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Coastal%20mountain%20road%20in%20soft%20morning%20mist%2C%20ocean%20visible%20in%20the%20distance%2C%20muted%20sage%20and%20warm%20sand%20color%20palette%2C%20quiet%20art%20house%20film%20still%2C%20gentle%20natural%20light%2C%20no%20text&width=1600&height=900&seq=backdrop-tashan-06&orientation=landscape",
    summary:
      "摄影师沈萄回到东部海岸整理母亲遗物，遇见守着旧民宿的女孩。两个不愿多说话的人，在十二集的沉默里交换了一整个夏天。",
    tags: ["文艺小品", "海岸线", "留白叙事"],
    releaseDate: "2024-09-14",
    analysis: [
      {
        title: "第一章 · 回来的理由",
        paragraphs: [
          "全剧几乎不用闪回，人物的过去都通过物件交代：一台坏掉的相机、一张没有寄出的明信片。这种处理让观众参与拼贴，也让情绪更耐看。",
          "海岸线的空镜占比很高，但并不空洞。每一次海浪声的变化，都对应着两人关系的一次微小位移。",
        ],
      },
      {
        title: "第二章 · 不说的话",
        paragraphs: [
          "台词极少，是本剧最大的冒险也是最成功的地方。两个主角用行动代替语言，收拾房间、修屋顶、煮一锅面，这些动作构成了另一种对白。",
          "第三集那场没有发生的争吵，是全剧的转折。导演把镜头停在门外，让观众自己听见沉默里的重量。",
        ],
      },
      {
        title: "第三章 · 夏天结束",
        paragraphs: [
          "结尾没有承诺，只有一张终于寄出的明信片。它没有解决任何现实问题，却让两个人都往前挪了一步，这是文艺剧最体面的收尾方式。",
          "适合在安静的晚上一次看完，像读完一本薄薄的手记。",
        ],
      },
    ],
  },
  {
    id: "bai-ta-zhi-xia",
    title: "白塔之下",
    enTitle: "Beneath the White Tower",
    year: 2025,
    region: "韩国",
    genres: ["悬疑", "家庭"],
    rating: 9.0,
    heat: 10240,
    episodes: 14,
    duration: "55分钟/集",
    director: "郑瑞渊",
    cast: ["徐智媛", "白承勋", "李恩彩", "崔到贤"],
    tagline: "最完美的家庭，住在最高的那层。",
    poster:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20poster%20of%20a%20modern%20white%20residential%20tower%20at%20dusk%20seen%20from%20below%2C%20one%20lit%20window%2C%20cold%20pale%20palette%20with%20a%20single%20warm%20amber%20light%2C%20unsettling%20symmetry%2C%20cinematic%2C%20no%20text&width=600&height=900&seq=poster-baita-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20luxury%20apartment%20tower%20interior%20corridor%20at%20night%2C%20cold%20white%20marble%20and%20glass%2C%20one%20warm%20amber%20door%20light%20at%20the%20end%2C%20uneasy%20symmetrical%20composition%2C%20cinematic%20thriller%20still%2C%20no%20text&width=1600&height=900&seq=backdrop-baita-07&orientation=landscape",
    summary:
      "一栋顶级住宅楼里，完美主妇的一天被一段监控录像撕开裂缝。当所有人都在维护体面，真相只能从最不起眼的佣人房里流出来。",
    tags: ["心理悬疑", "阶级寓言", "高分神剧"],
    releaseDate: "2025-05-30",
    analysis: [
      {
        title: "第一章 · 完美的一天",
        paragraphs: [
          "第一集用近乎广告片的镜头语言展示这个家庭的完美，直到最后一个镜头，镜头才第一次下降到地下室。这种视觉上的「垂直权力」贯穿全剧。",
          "剧集对声音的处理极为讲究：电梯提示音、洗碗机、空调低频，这些日常噪音在关键时刻变成压迫感来源。",
        ],
      },
      {
        title: "第二章 · 体面的价格",
        paragraphs: [
          "中段逐渐揭示，这个家庭的每一个成员都在为「体面」支付不同的代价。剧本没有把任何人写成纯粹的恶人，而是让每个人都成为结构的一部分。",
          "李恩彩饰演的佣人是全剧的观察者，她的视角让观众得以从底层重新审视这座塔，也让结尾的爆发有了正当性。",
        ],
      },
      {
        title: "第三章 · 塔的裂缝",
        paragraphs: [
          "大结局没有让塔倒塌，而是让灯一盏盏灭掉。这个意象比任何控诉都更冷，也更有说服力。",
          "值得注意的细节是，全剧从未出现过塔的完整外观，只有仰视和俯视——视角本身就是这部剧的主题。",
        ],
      },
    ],
  },
  {
    id: "ni-hong-an-xiang",
    title: "霓虹暗巷",
    enTitle: "Neon Alley",
    year: 2024,
    region: "日本",
    genres: ["犯罪", "悬疑"],
    rating: 8.3,
    heat: 6890,
    episodes: 10,
    duration: "52分钟/集",
    director: "石田川",
    cast: ["黑木凉", "佐仓凛", "高桥诚"],
    tagline: "灯越亮，影子越深。",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20neo-noir%20poster%20of%20a%20narrow%20alley%20in%20a%20neon-lit%20city%20at%20night%2C%20rain%20and%20steam%2C%20magenta-free%20palette%20of%20deep%20navy%2C%20teal%20and%20warm%20orange%20neon%2C%20high%20contrast%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=poster-nihong-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Neon-lit%20narrow%20Tokyo%20alley%20at%20night%20in%20the%20rain%2C%20steam%20from%20vents%2C%20wet%20pavement%20reflections%20in%20teal%20and%20warm%20orange%2C%20deep%20navy%20shadows%2C%20neo-noir%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=backdrop-nihong-08&orientation=landscape",
    summary:
      "一名替人跑腿的中间人，在一条即将拆迁的巷子里接到最后一单生意。十集之内，他要找出谁在利用这条街的消失洗掉一切。",
    tags: ["霓虹美学", "黑色电影", "十集短剧"],
    releaseDate: "2024-12-08",
    analysis: [
      {
        title: "第一章 · 最后一单",
        paragraphs: [
          "开场的三分钟没有任何台词，只有人物穿过巷子的过程。观众通过他避开谁、在哪里停下，就理解了这条街的势力分布，这是极高效的世界观建立。",
          "导演坚持使用实景霓虹光源，让人物脸上永远有一半在阴影里，这种打光方式直接定义了全剧的道德灰度。",
        ],
      },
      {
        title: "第二章 · 拆迁的逻辑",
        paragraphs: [
          "案件表面是谋杀，内里是地产。剧本把犯罪动机牢牢绑定在城市更新上，让每一次暴力都有了经济理由，也让结局的无力感更有依据。",
          "佐仓凛饰演的记者提供了外部视角，她的职业困境与主角的生存困境形成互文。",
        ],
      },
      {
        title: "第三章 · 巷子消失之后",
        paragraphs: [
          "结尾巷子被围挡封住，主角站在围挡外抽完一支烟。没有正义，也没有彻底的失败，只有一个人确认自己还活着。",
          "这部剧最值得学的是节奏：十集没有一处废戏，每集结尾都留一个必须点下一集的钩子。",
        ],
      },
    ],
  },
  {
    id: "er-ci-gao-bai",
    title: "二次告白",
    enTitle: "Confess Again",
    year: 2025,
    region: "中国大陆",
    genres: ["爱情", "喜剧"],
    rating: 7.9,
    heat: 7210,
    episodes: 24,
    duration: "38分钟/集",
    director: "何岸",
    cast: ["夏林", "顾承", "白小满"],
    tagline: "第一次是冲动，第二次才是答案。",
    poster:
      "https://readdy.ai/api/search-image?query=Bright%20romantic%20comedy%20poster%20of%20a%20young%20couple%20standing%20back%20to%20back%20on%20a%20city%20rooftop%20at%20sunset%2C%20warm%20peach%20and%20cream%20palette%2C%20playful%20light%20leaks%2C%20cheerful%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-ercigao-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=City%20rooftop%20at%20golden%20sunset%20with%20string%20lights%20and%20potted%20plants%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20lens%20flare%2C%20cheerful%20romantic%20comedy%20film%20still%2C%20no%20text&width=1600&height=900&seq=backdrop-ercigao-09&orientation=landscape",
    summary:
      "婚礼策划师夏林接到了前男友的婚礼订单。为了体面完成工作，她编了一个假男友，没想到对方比她更会演。",
    tags: ["轻喜剧", "都市情感", "高糖"],
    releaseDate: "2025-01-17",
    analysis: [
      {
        title: "第一章 · 一份尴尬的订单",
        paragraphs: [
          "剧集把喜剧建立在职业尴尬上，而非低智误会，这让人物始终保有尊严。女主接下订单的动机也很清楚：她要证明自己过得很好。",
          "假男友这个设定本不新鲜，但剧本给了他一个可信的职业背景，让他的「演技」有了来源。",
        ],
      },
      {
        title: "第二章 · 演着演着",
        paragraphs: [
          "中段开始，谎言的维护成本越来越高，喜剧逐渐转向情感。两人在便利店门口那场没有台词的沉默，是全剧最好的一场戏。",
          "配角白小满承担了大量笑点，但没有沦为工具人，她自己的感情线也在悄悄推进。",
        ],
      },
      {
        title: "第三章 · 第二次",
        paragraphs: [
          "结局没有安排抢婚，而是让女主在婚礼结束后主动说出真话。这个处理更成熟，也更符合人物成长。",
          "如果你想找一部不费脑但有心跳的剧，它很合适。",
        ],
      },
    ],
  },
  {
    id: "qun-shan-hui-xiang",
    title: "群山回响",
    enTitle: "Echoes of the Hills",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "年代"],
    rating: 8.8,
    heat: 6350,
    episodes: 40,
    duration: "47分钟/集",
    director: "李正阳",
    cast: ["沈国梁", "秦书玉", "沈知远", "何秀"],
    tagline: "山不会回答，但会记住。",
    poster:
      "https://readdy.ai/api/search-image?query=Rural%20period%20drama%20poster%20of%20an%20old%20man%20walking%20on%20a%20mountain%20path%20with%20terraced%20fields%2C%20muted%20earth%20green%20and%20warm%20ochre%20palette%2C%20soft%20haze%2C%20documentary-like%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-qunshan-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Terraced%20mountain%20village%20at%20dawn%20with%20morning%20mist%2C%20stone%20houses%20and%20winding%20path%2C%20muted%20earth%20green%20and%20warm%20ochre%20tones%2C%20documentary%20style%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=backdrop-qunshan-10&orientation=landscape",
    summary:
      "一个山村教师用四十年时间，把一批批孩子送出大山。四十集里没有惊天动地的大事，只有一条路上反复出现的脚印。",
    tags: ["年代群像", "现实主义", "长线叙事"],
    releaseDate: "2023-10-09",
    analysis: [
      {
        title: "第一章 · 一个人的学校",
        paragraphs: [
          "开篇用极朴素的镜头记录一间漏雨的教室，没有配乐，也没有煽情台词。这种克制让后续所有情感爆发都显得可信。",
          "剧本用「学生名单」作为贯穿道具，每一集划掉一个名字，就代表一个孩子离开。名单本身就是一部编年史。",
        ],
      },
      {
        title: "第二章 · 留下与离开",
        paragraphs: [
          "剧集没有把「走出大山」写成唯一的正确答案。留下的年轻人、回来的年轻人，都有自己的理由，这种多声部处理是本剧最难得的清醒。",
          "沈国梁的表演几乎没有技巧痕迹，他把一个固执、笨拙又温柔的人演得像真的存在过。",
        ],
      },
      {
        title: "第三章 · 回响",
        paragraphs: [
          "结尾，已经成为工程师的学生带回一张新校舍的图纸。老师只是摆摆手说「太亮了，孩子们会睡不着」，然后转身继续擦黑板。",
          "这一句台词足以概括全剧：改变要慢慢来，但必须有人先开始。",
        ],
      },
    ],
  },
  {
    id: "wu-zhong-lie-che",
    title: "雾中列车",
    enTitle: "Train in the Mist",
    year: 2024,
    region: "英国",
    genres: ["悬疑", "剧情"],
    rating: 8.6,
    heat: 5980,
    episodes: 8,
    duration: "58分钟/集",
    director: "艾略特·哈里斯",
    cast: ["艾玛·沃德", "乔纳森·里德", "米娅·科尔"],
    tagline: "车上没有陌生人，只有还没被认出的过去。",
    poster:
      "https://readdy.ai/api/search-image?query=British%20mystery%20series%20poster%20of%20an%20old%20night%20train%20carriage%20interior%20with%20warm%20lamps%20and%20fog%20outside%20windows%2C%20deep%20forest%20green%20and%20amber%20palette%2C%20elegant%20moody%20period%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-wuzhong-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Old%20steam%20train%20crossing%20a%20misty%20moor%20at%20dusk%2C%20warm%20carriage%20windows%20glowing%2C%20deep%20forest%20green%20and%20amber%20tones%2C%20cinematic%20wide%20shot%2C%20atmospheric%20fog%2C%20no%20text&width=1600&height=900&seq=backdrop-wuzhong-11&orientation=landscape",
    summary:
      "一列因大雾停驶的夜班列车，八名乘客，一具尸体。列车长必须在救援到来前找出凶手，却发现每个人都在等这趟车出事。",
    tags: ["密室推理", "英伦质感", "八集限定"],
    releaseDate: "2024-02-16",
    analysis: [
      {
        title: "第一章 · 停驶",
        paragraphs: [
          "密闭空间的最大难题是如何避免舞台感，本剧的解法是让列车持续「轻微运动」——晃动、蒸汽、门缝的风，让空间始终不安。",
          "八名乘客的出场顺序经过精心设计，每个人的第一句台词都埋了自己的秘密，这是非常古典也有效的写法。",
        ],
      },
      {
        title: "第二章 · 证词的形状",
        paragraphs: [
          "剧集对「不可靠叙述」的使用堪称教学范本：同一件事被三个人讲了三遍，观众需要自己判断哪一版更接近真相。",
          "中段揭开的不是凶手，而是这趟列车的调度记录。当制度成为共犯，个人推理才开始显得无力。",
        ],
      },
      {
        title: "第三章 · 雾散之后",
        paragraphs: [
          "结局让真相在晨光里被平淡地说出来，没有对峙高潮。这种处理与全剧的英式克制高度统一，也让最后一个镜头格外冷。",
          "八集长度刚刚好，是那种适合一个周末看完的精致小品。",
        ],
      },
    ],
  },
  {
    id: "chang-an-ye-xing",
    title: "长安夜行",
    enTitle: "Night Walk in Chang'an",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "悬疑"],
    rating: 8.5,
    heat: 8450,
    episodes: 28,
    duration: "44分钟/集",
    director: "崔行",
    cast: ["裴照", "柳如晦", "李清和"],
    tagline: "一座城的夜色，藏得住所有秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20period%20mystery%20poster%20of%20a%20Tang%20dynasty%20official%20in%20dark%20robes%20holding%20a%20lantern%20in%20a%20snowy%20ancient%20street%2C%20deep%20ink%20blue%20and%20warm%20lantern%20amber%20palette%2C%20elegant%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=poster-changan-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Tang%20dynasty%20city%20street%20at%20night%20with%20lanterns%20and%20light%20snow%2C%20wooden%20architecture%2C%20deep%20ink%20blue%20tones%20with%20warm%20amber%20lantern%20light%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=backdrop-changan-12&orientation=landscape",
    summary:
      "长安城宵禁之后，一位掌管刑狱的小吏接连遇到三桩怪案。线索指向同一座废弃的坊，也指向他十年前做过的一个决定。",
    tags: ["唐风探案", "单元剧", "东方美学"],
    releaseDate: "2025-09-26",
    analysis: [
      {
        title: "第一章 · 宵禁之后",
        paragraphs: [
          "剧集用宵禁制度制造天然密室，坊墙、更鼓、巡夜人构成了一个精密的时间系统，案件必须在这个系统里发生。",
          "美术上刻意避开金碧辉煌，选择雪、墨、灯三种元素，让长安看起来清冷而有秩序，这种审美与探案气质高度统一。",
        ],
      },
      {
        title: "第二章 · 三个案子一条线",
        paragraphs: [
          "三个单元案看似独立，实则共享同一批证人。剧本用「同一句口供在不同案子里含义相反」的方式制造趣味，非常耐琢磨。",
          "主角不是天才，他会犯错，也会因为官场规矩放走嫌疑人，这种妥协让角色立住了。",
        ],
      },
      {
        title: "第三章 · 十年前的决定",
        paragraphs: [
          "最终案的动机回到主角自身，这是一次大胆的处理：他追查的其实是自己当年的沉默。结局没有翻案，只有一份被烧掉的卷宗。",
          "如果喜欢慢工出细活的古装探案，这部值得排进片单。",
        ],
      },
    ],
  },
];